/**
 * Created by juniusang on 5/24/17.
 */
import { Platform, Dimensions, StatusBar } from 'react-native';
import Logger from './Logger';
import DRNException from '../exception-type/DRNException';
const DRNUtil = {
    isiOS: () => {
        return Platform.OS === 'ios';
    },
    isAndroid: () => {
        return Platform.OS === 'android';
    },
    isWeb: () => {
        return Platform.OS === 'web';
    },
    isAndroidUI: () => {
        return Platform.OS !== 'ios';
    },
    isIphoneX: () => {
        const dimen = Dimensions.get('window');
        return (Platform.OS === 'ios' &&
            !Platform.isPad &&
            !Platform.isTVOS &&
            (dimen.height === 812 || dimen.width === 812 || (dimen.height === 896 || dimen.width === 896)));
    },
    /**
     * Get the real value of status bar height
     * @see https://github.com/ovr/react-native-status-bar-height/blob/0357fd677a80d3d7a092bda8aab913e7671728ea/index.js#L17
     */
    getRawStatusBarHeight: () => {
        return Platform.select({
            ios: DRNUtil.isIphoneX() ? 44 : 20,
            android: StatusBar.currentHeight,
            default: 0,
        });
    },
    /**
     * Get status bar height with android UI assigned to 0
     * This is useful for managing View to start under StatusBar
     */
    getStatusBarHeight: () => {
        return DRNUtil.isAndroidUI() ? 0 : DRNUtil.getRawStatusBarHeight();
    },
    /**
     * Get navigation bar height depending on platform
     * @see https://github.com/react-navigation/react-navigation-stack/blob/f3f6191286822603fcf238a065e0088ec576a776/src/views/Header/Header.js#L20
     */
    getNavBarHeight: () => {
        return DRNUtil.isiOS() ? 44 : 56;
    },
    /**
     * Get app bar height depending on platform (navbar height + statusbar height)
     * @see https://github.com/react-navigation/react-navigation-stack/blob/f3f6191286822603fcf238a065e0088ec576a776/src/views/Header/Header.js#L73
     */
    getAppBarHeight: () => {
        return DRNUtil.getNavBarHeight() + DRNUtil.getStatusBarHeight();
    },
    /**
     * Get bottom inset height depending on platform
     * @see https://github.com/react-native-community/react-native-safe-area-view/blob/5000a8af587e8fe4f1068a1e81edb5b6f4f5da33/index.js#L342
     */
    getBottomInsetHeight: () => {
        return DRNUtil.isIphoneX() ? 34 : 0;
    },
    // Logger
    log: (value, header = 'DISTRICT_JS') => {
        __DEV__ && console.log(header, JSON.stringify(value));
        Logger.log(value);
    },
    warn: (value) => {
        Logger.warn(value);
    },
    display: (value) => {
        Logger.display(value);
    },
    error: (value) => {
        Logger.error(value);
    },
    clearLog: () => {
        __DEV__ && console.clear();
        Logger.clear();
    },
    setLogger: (logger) => {
        __DEV__ && Logger.setLogger(logger);
    },
    getScreenWidth: () => {
        const { width } = Dimensions.get('window');
        return width;
    },
    getScreenHeight: () => {
        const { height } = Dimensions.get('window');
        return height;
    },
    /**
     * Only test if object empty( {} ) or not
     * for more comprehensive check, please use isObjectNotNullUndefinedEmpty
     *
     * @param {*} objToCheck must be a valid object {}
     * @returns true if empty
     */
    isObjectEmpty: (objToCheck) => {
        if (objToCheck === null) {
            throw DRNException.NullPointerException(objToCheck, '[DRNUtil.isObjectEmpty] objToCheck cannot null');
        }
        if (objToCheck !== Object(objToCheck)) {
            throw DRNException.NotAnObjectException(objToCheck, '[DRNUtil.isObjectEmpty] objToCheck is not an object');
        }
        return Object.keys(objToCheck).length === 0 && objToCheck.constructor === Object;
    },
    /**
     * handle string checking, and common object checking
     * Will safely return false if parameter provided is not an Object
     * @param {*} objToCheck if String, it will check if string empty or not, if common Object will check the content to be not null & not undefined & not empty
     * @returns true if object is strictly correct in form.
     */
    isObjectNotNullUndefinedEmpty: (objToCheck) => {
        const result = objToCheck !== null && objToCheck !== undefined;
        // check if object is primitive numeric value
        if (result && !isNaN(objToCheck)) {
            return false;
        }
        if (result && (typeof objToCheck === 'string' || objToCheck instanceof String)) {
            return objToCheck.length > 0;
        }
        if (result) {
            return !(Object.keys(objToCheck).length === 0 && objToCheck.constructor === Object);
        }
        return false;
    },
};
export default DRNUtil;
